import React, { useRef, useState } from 'react'
import { Button, Form, FormCheck, InputGroup } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Text from '../../components/input_fields/Text';
import { useFormik } from 'formik';
import TextArea from '../../components/input_fields/TextArea';
import * as Yup from 'yup';
import { debounce } from 'lodash';
import { citySearch } from '../../redux/slice/CitySearch';
import SingleSelect from '../../components/input_fields/SingleSelect';
import { useDispatch, useSelector } from 'react-redux';
import SelectBox from '../../components/input_fields/SelectBox';
import { updateCheckoutDetails } from '../../redux/slice/UpdateCheckoutDetails';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { createOrder } from '../../redux/slice/CreateOrder';
import { verifyPayment } from '../../redux/slice/VerifyPayment';
import { linkList } from '../../redux/slice/LinkList';
import Spinner from 'react-bootstrap/Spinner';
import { applyCoupon } from '../../redux/slice/ApplyCoupon';
import { verifyGst } from '../../redux/slice/VerifyGst';
import { FaBuilding, FaUser } from 'react-icons/fa';
import { cityStateGst } from '../../redux/slice/CityStateGst';
import { certificateList } from '../../redux/slice/CertificateList';

export default function CheckoutPage() {
    const location = useLocation();
    const { data, linkData, subscription_plan, link_plan } = location.state || {};
    const attentionRef = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [spinner, setSpinner] = useState(false)
    const [loading, setLoading] = useState(false)
    const [cityLoading, setCityLoading] = useState(false)
    const cityData = useSelector(state => state?.citySearch?.data)
    const cityStateData = useSelector(state => state?.cityStateGst?.data)
    const certificate = useSelector(state => state?.certificateList?.data)
    const user = useSelector((state) => state?.auth?.user);
    const [sId, setSid] = useState('')
    const [countryId, setCountryId] = useState('')

console.log(certificate);
    // Coupon states
    const [couponCode, setCouponCode] = useState('');
    const [couponLoading, setCouponLoading] = useState(false);
    const [verifyLoading, setVerifyLoading] = useState(false);
    const [couponData, setCouponData] = useState('');
    const [couponMsg, setCouponMsg] = useState('');
    const [couponError, setCouponError] = useState('');
    const [gstverifyError, setGstVerifyError] = useState('');
    const [isGstVerified, setIsGstVerified] = useState(false);

    const toEnglishOnly = (value) => value.replace(/[^\x20-\x7E]/g, '');
    const toEnglishLettersOnly = (value) => value.replace(/[^A-Za-z\s]/g, '');

    const handleApplyCoupon = () => {
        setCouponLoading(true);
        dispatch(applyCoupon({ coupon_name: couponCode, planId: data._id })).then((res) => {
            if (res?.payload?.status === 200 || res?.payload?.status === 201) {
                setCouponLoading(false);
                setCouponData(res?.payload?.data?.data?.[0] || null);
                setCouponMsg(res?.payload?.data?.message)
                setCouponError(false);

            } else {
                setCouponLoading(false);
                setCouponMsg(res?.payload?.data?.message || 'Invalid coupon code');
                setCouponData('');
                setCouponError(true);
            }
        });
    }

    const removeCoupon = () => {
        setCouponData('');
        setCouponMsg('');
        setCouponError(false);
        setCouponCode('');
    }

    const scrollToAttention = () => {
        attentionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const load_city = debounce((e) => {
        if (e) {

            setCityLoading(true)
            dispatch(citySearch({ city: e, navigate })).then((res) => setCityLoading(false))
        }
    }, 500)




    const handleBuyPlan = async () => {
        const price = parseFloat(data.price) || 0;
        if (price === 0) return;

        // Check if Razorpay is loaded
        if (!window.Razorpay) {
            toast.error('Razorpay is not loaded. Please refresh the page and try again.', { position: "bottom-right" });
            return;
        }

        try {
            const orderResult = await dispatch(createOrder({
                plan_id: data._id,
                sid: sId,
                order_type: values?.customer_type,
                coupon_name: couponData?.name || '',
            }));

            if ((orderResult.payload?.status !== 200 && orderResult.payload?.status !== 201) || orderResult.payload?.data?.status !== true) {
                const errorMessage = orderResult.payload?.data?.message || 'Failed to create order';
                toast.error(errorMessage, { position: "bottom-right" });
                setSpinner(false);
                return;
            }

            const orderData = orderResult.payload?.data?.data;
            const orderId = orderData?.[0]?.razorpay_order_id || '';

            if (!orderId) {
                toast.error('Order ID not received from server', { position: "bottom-right" });
                setSpinner(false);
                return;
            }

            const options = {
                key: process.env.REACT_APP_RAZORPAY_KEY || 'YOUR_RAZORPAY_KEY_ID',
                amount: price * 100, // Amount in paise (multiply by 100 for rupees)
                currency: data.currency || 'INR',
                name: data.plan_name || data.name || 'Plan Purchase',
                description: data.description || `Purchase ${data.plan_name || data.name || 'Plan'}`,
                image: '', // Optional: Your logo URL
                order_id: orderId, // Use order_id from create_order API
                handler: async function (response) {
                    // Handle successful payment
                    console.log('Payment successful:', response);

                    try {
                        // Verify payment with backend
                        const verifyResult = await dispatch(verifyPayment({
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_signature: response.razorpay_signature,
                            link_id: linkData?._id || '',
                        }));

                        if ((verifyResult.payload?.status === 200 || verifyResult.payload?.status === 201) && verifyResult.payload?.data?.status === true) {
                            toast.success(verifyResult.payload?.data?.message || 'Payment verified successfully!', {
                                position: "bottom-right",
                                closeOnClick: true
                            });
                            setSpinner(false);
                            // Refresh link list after successful payment verification
                            await dispatch(linkList());
                            // Navigate to short-links page after successful payment
                            { link_plan == true ? navigate('/short-links') : subscription_plan == true ? navigate('/bio-page') : navigate('/plans') }
                        } else {
                            const errorMessage = verifyResult.payload?.data?.message || 'Payment verification failed';
                            toast.error(errorMessage, { position: "bottom-right" });
                            setSpinner(false);
                        }
                    } catch (error) {
                        console.error('Error verifying payment:', error);
                        toast.error('Error verifying payment. Please contact support.', { position: "bottom-right" });
                        setSpinner(false);
                    }
                },
                prefill: {
                    name: user?.name || user?.user?.name || '',
                    email: user?.email || user?.user?.email || '',
                    contact: user?.phone || user?.user?.phone || user?.contact || '',
                },
                notes: {
                    plan_id: data.id,
                    plan_name: data.plan_name || data.name,
                },
                theme: {
                    color: '#667eea'
                },
                modal: {
                    ondismiss: function () {
                        console.log('Payment modal closed');
                    }
                }
            };

            const razorpay = new window.Razorpay(options);
            razorpay.open();

            razorpay.on('payment.failed', function (response) {
                console.error('Payment failed:', response.error);
                toast.error('Payment failed. Please try again.', { position: "bottom-right" });
                setSpinner(false);
            });
        } catch (error) {
            console.error('Error creating order:', error);
            toast.error('An error occurred. Please try again.', { position: "bottom-right" });
            setSpinner(false);
        }
    };



    const initialValues = {
        customer_type: localStorage.getItem('gstnumber') ? 'company' : 'individual',
        name: localStorage.getItem('name') || '',
        email: localStorage.getItem('email') || '',
        city: localStorage.getItem('gstnumber') ? (localStorage.getItem('city_id') || '') : '',
        address: localStorage.getItem('gstnumber') ? (localStorage.getItem('address') || '') : '',
        company_name: localStorage.getItem('company_name') || '',
        gst: localStorage.getItem('gstnumber') ? (localStorage.getItem('gstnumber') || '') : '',
        gst_code: localStorage.getItem('gstnumber') ? (localStorage.getItem('gst_code') || '') : '',
        terms: false,
    };


    const checkoutSchema = Yup.object({
        customer_type: Yup.string().required(),
        name: Yup.string().required('Full Name is required')
            .matches(/^[A-Za-z.\s]+$/, 'Only alphabets, dot and space are allowed')
            .min(5, 'Full Name must be 5 characters or more')
            .max(125, 'Full Name must be 125 characters or less')
        ,
        email: Yup.string()
            .email('Please enter a valid email address')
            .required('Email is required'),
        city: Yup.string().required('City is required'),
        terms: Yup.boolean().oneOf([true], 'You must agree to the terms and conditions'),
        address: Yup.string().when('customer_type', {
            is: 'individual',
            then: (schema) => schema
                .required('Address is required')
                .matches(/^[A-Za-z\s]+$/, 'Only English letters and spaces are allowed')
                .min(10, 'Address must be 10 characters or more')
                .max(256, 'Address must be 256 characters or less'),
            otherwise: (schema) => schema
                .required('Address is required')
                .min(16, 'Address must be 16 characters or more')
                .max(512, 'Address must be 512 characters or less'),
        }),
        company_name: Yup.string().when('customer_type', {
            is: 'company',
            then: (schema) => schema.required('Company name is required'),
            otherwise: (schema) => schema,
        }),
        gst: Yup.string()
            .matches(/^$|^[0-9]{2}(?!ABBCA1435G)[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z][ZGFCHDT][0-9A-Z]$/, 'Please enter a valid GST number')
        // .test(
        //     'gst-city-match',
        //     'GST state code doesn’t match selected city state code.',
        //     function (value) {
        //         const { gst_code } = this.parent;
        //         if (!value || !gst_code) return true;
        //         return value.substring(0, 2) === String(gst_code).padStart(2, '0');
        //     }
        // ),

    });



    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue, setFieldTouched } = useFormik({
        initialValues: initialValues,
        validationSchema: checkoutSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            if (values.customer_type === 'company' && !isGstVerified) {
                setGstVerifyError('Please verify your GST number before proceeding.');
                toast.error('Please verify your GST number before proceeding.', { position: 'bottom-right' });
                return;
            }
            setSpinner(true);
            const checkoutPayload = values.customer_type === 'company'
                ? values
                : {
                    name: values.name,
                    city: values.city,
                    address: values.address,
                    customer_type: values.customer_type,
                };
            dispatch(updateCheckoutDetails(checkoutPayload)).then((res) => {

                if (res?.payload?.status == 200 || res?.payload?.status == 201) {

                    if (values.customer_type === 'company') {
                        localStorage.setItem('name', values.name)
                        localStorage.setItem('city_id', values.city)
                        localStorage.setItem('city_name', city_option?.find(val => val.value == values.city)?.label || '')
                        localStorage.setItem('company_name', values.company_name)
                        localStorage.setItem('address', values.address)
                        localStorage.setItem('gstnumber', values.gst)
                        localStorage.setItem('gst_code', values.gst_code || '')
                    }
                    handleBuyPlan()
                }
                else {
                    setSpinner(false);
                }
            });
        }
    });

    const handleAddressChange = (e) => {
        let value = values.customer_type === 'individual'
            ? toEnglishLettersOnly(e.target.value)
            : e.target.value;
        if (values.customer_type === 'individual') {
            value = value.slice(0, 256);
        }
        setFieldValue('address', value);
    };

    const finalCityData = (values.customer_type === 'company' && cityStateData?.length > 0) ? cityStateData : cityData;

    const city_option = finalCityData?.map(val => (
        {
            'value': val._id,
            'label': val.city,
            'state': val.sid,
            'country': val.cid,
            'state_name': val?.state?.state,
            'country_name': val?.country?.name,
            'gst_code': val?.gstcode
        }
    ))

    const city_option_gst = cityStateData?.map(val => (
        {
            'value': val._id,
            'label': val.city,
            'state': val.sid,
            'country': val.cid,
            'state_name': val?.state?.state,
            'country_name': val?.country?.name,
            'gst_code': val?.gstcode
        }
    ))

    useEffect(() => {
        dispatch(certificateList({ navigate })).then((res) => list_res(res))
        if (localStorage.getItem('gstnumber') && localStorage.getItem('city_name')) {
            setCityLoading(true)
            dispatch(citySearch({ city: localStorage.getItem('city_name') || '', navigate })).then((res) => city_res(res.payload))
        }
        if (localStorage.getItem('gstnumber')) {
            setIsGstVerified(true)
        }

    }, [])

    const list_res = (res) => {
        if (res?.payload?.status == 200) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const city_res = (res) => {
        if (res?.status == 200) {
            setCityLoading(false)
            setSid(res?.data?.data?.[0]?.sid || '23')
            setCountryId(res?.data?.data?.[0]?.cid || '101')
            setFieldValue('gst_code', res?.data?.data?.[0]?.gstcode || '')
        } else {
            setCityLoading(false)
        }
    }



    const selectedCityGstCode = city_option?.find(val => val.value == values.city)?.gst_code;
    const effectiveGstCode = selectedCityGstCode ?? values.gst_code;
    const isSameState = values.customer_type === 'company' && values.gst
        ? values.gst.substring(0, 2) === "23"
        : String(effectiveGstCode).padStart(2, '0') === "23";

    const hasCertificate = Array.isArray(certificate)
        ? certificate.length > 0
        : !!(certificate && typeof certificate === 'object' && Object.keys(certificate).length > 0);
    // Certificate + non-India country → no tax/IGST
    const showTaxBreakdown = !(hasCertificate && countryId && String(countryId) !== '101');
    const isIndia = !countryId || String(countryId) === '101';
    const currencySymbol = isIndia ? '₹' : '$';
    const currencyCode = isIndia ? 'INR' : 'USD';
    const planMrp = isIndia ? (data?.mrp || 0) : (data?.mrp_usd || 0);
    const planPrice = isIndia ? (data?.price || 0) : (data?.price_usd || 0);
    const planTotal = isIndia ? (data?.totalamount || 0) : (data?.totalamount_usd || 0);
    const couponAmount = isIndia
        ? (couponData?.coupon_amount || 0)
        : (couponData?.coupon_amount_usd || 0);
    const discountedPrice = couponData ? (planPrice - couponAmount) : planPrice;
    const taxAmount = showTaxBreakdown ? discountedPrice * data?.tax / 100 : 0;
    const totalAmount = showTaxBreakdown
        ? (couponData ? discountedPrice + taxAmount : planTotal || 0)
        : (couponData ? discountedPrice : planPrice || 0);

    const restoreCompanyDetails = () => {
        const cityId = localStorage.getItem('city_id') || '';
        const cityName = localStorage.getItem('city_name') || '';

        setFieldValue('city', cityId);
        setFieldValue('gst_code', localStorage.getItem('gst_code') || '');
        setFieldValue('company_name', localStorage.getItem('company_name') || '');
        setFieldValue('address', localStorage.getItem('address') || '');
        setFieldValue('gst', localStorage.getItem('gstnumber') || '');

        if (localStorage.getItem('gstnumber')) {
            setIsGstVerified(true);
        }

        if (cityName) {
            setCityLoading(true);
            dispatch(citySearch({ city: cityName, navigate })).then((res) => city_res(res.payload));
        }
    };

    const handleCustomerTypeChange = (e) => {
        handleChange(e);
        if (e.target.value === 'company') {
            setFieldValue('company_name', '');
            setFieldValue('city', '');
            setFieldValue('address', '');
            setFieldValue('gst', '');
            setFieldValue('gst_code', '');
            setIsGstVerified(false);
            setSid('');
            setCountryId('');
        } else {
            setFieldValue('city', '');
            setFieldValue('address', '');
            setFieldValue('gst', '');
            setFieldValue('gst_code', '');
            setIsGstVerified(false);
            setSid('');
            setCountryId('');
        }
    };

    const verify_gst = (gst) => {
        setVerifyLoading(true)
        dispatch(verifyGst(gst)).then((res) => {
            if (res?.payload?.status === 200) {
                setIsGstVerified(true)
                const decodedData = JSON.parse(atob(res?.payload?.data?.data))
                console.log("gstData", decodedData)

                const companyName = decodedData?.company_details?.legal_name || '';
                const gstin = decodedData?.gstin || '';
                const cityNm = decodedData?.company_details?.pradr?.city || '';
                const stateNm = decodedData?.company_details?.state_info?.name || '';
                const addr = `${decodedData?.company_details?.pradr?.addr1 || ''} ${decodedData?.company_details?.pradr?.addr2 || ''} ${decodedData?.company_details?.pradr?.street || ''} ${decodedData?.company_details?.pradr?.pincode || ''} `;

                localStorage.setItem('company_name', companyName)
                localStorage.setItem('gstnumber', gstin)
                localStorage.setItem('city_name', cityNm)
                localStorage.setItem('address', addr)

                setFieldValue('company_name', companyName)
                setFieldValue('address', addr)
                setFieldValue('customer_type', 'company')
                setGstVerifyError('')

                dispatch(cityStateGst({ city: cityNm, state: stateNm, navigate })).then((cRes) => {
                    setVerifyLoading(false)
                    if (cRes?.payload?.status === 200) {
                        const city_data = cRes?.payload?.data?.data?.[0]
                        if (city_data) {
                            localStorage.setItem('city_id', city_data?._id || '')
                            localStorage.setItem('gst_code', city_data?.gstcode || '')
                            setFieldValue('city', city_data?._id || '')
                            setFieldValue('gst_code', city_data?.gstcode || '')
                            setSid(city_data?.sid || '23')
                        }
                    }
                })
            } else {
                setVerifyLoading(false)
                setIsGstVerified(false)
                setFieldValue('customer_type', 'company')
                setGstVerifyError(res?.payload?.data?.message)
            }
        })
    }


    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout'>
                            <h5>Checkout Page</h5>
                        </div>
                    </div>
                    <div className="col-md-12 mt-2">
                        <Form>
                            <div className='layout '>
                                <div className="row">
                                    <div className="col-md-6 ">
                                        <div className='row p-5'>
                                            <div className="col-md-12">
                                                <Text
                                                    label_name={"Full Name"}
                                                    placeholder=''
                                                    disabled={true}
                                                    name='name'
                                                    readOnly={false}
                                                    value={values.name || ''}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={errors.name && touched.name ? (<span className='text-danger form_label'>{errors.name}</span>) : null}
                                                />
                                            </div>
                                            <div className="col-md-12">
                                                <Text
                                                    label_name={"Email"}
                                                    placeholder=''
                                                    disabled={true}
                                                    name='email'
                                                    value={values.email || ''}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={errors.email && touched.email ? (<span className='text-danger form_label'>{errors.email}</span>) : null}
                                                />
                                            </div>
                                            <div className="col-md-12 mb-3 mt-2">
                                                <div className="d-flex gap-4">
                                                    <Form.Check
                                                        type="radio"
                                                        label={
                                                            <span>
                                                                <FaUser style={{ marginRight: "5px", marginBottom: '3px' }} />
                                                                For Individual
                                                            </span>
                                                        }
                                                        name="customer_type"
                                                        id="individual"
                                                        value="individual"
                                                        checked={values.customer_type === 'individual'}
                                                        onChange={handleCustomerTypeChange}
                                                    />
                                                    <Form.Check
                                                        type="radio"
                                                        label={
                                                            <span>
                                                                <FaBuilding size={17} style={{ marginRight: "5px", marginBottom: '3px' }} />
                                                                For Company
                                                            </span>
                                                        }
                                                        name="customer_type"
                                                        id="company"
                                                        value="company"
                                                        checked={values.customer_type === 'company'}
                                                        onChange={handleCustomerTypeChange}
                                                    />
                                                </div>
                                            </div>
                                            {values.customer_type === 'company' && (<div className="col-md-12 mb-3">
                                                {/* <Text
                                                    label_name={"GSTIN"}
                                                    placeholder=''
                                                    disabled={false}
                                                    name='gst'
                                                    value={values.gst || ''}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={errors.gst && touched.gst ? (<span className='text-danger form_label'>{errors.gst}</span>) : null}
                                                /> */}
                                                <Form.Label className='form_label'>{"GSTIN"}</Form.Label>
                                                <InputGroup className="">
                                                    <Form.Control
                                                        type="text"
                                                        aria-label="GSTIN"
                                                        aria-describedby="basic-addon2"
                                                        placeholder=''
                                                        disabled={false}
                                                        className='form_input'
                                                        name='gst'
                                                        value={values.gst || ''}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                    <Button
                                                        variant="primary"
                                                        id="basic-addon2"
                                                        disabled={!!errors.gst || !values.gst || verifyLoading}
                                                        size="sm"
                                                        onClick={() => {
                                                            verify_gst(values.gst)
                                                        }}
                                                    >
                                                        {verifyLoading ? <Spinner animation="border" size="sm" /> : 'VERIFY GST'}
                                                    </Button>
                                                </InputGroup>
                                                <span className='text-danger' style={{ fontSize: '14px' }}>{gstverifyError}</span>
                                                {errors.gst && touched.gst ? (<span className='text-danger form_label'>{errors.gst}</span>) : null}
                                                {values.gst && values.gst.length >= 14 && values.gst.charAt(13).toUpperCase() === 'F' && (
                                                    <div className='text-info form_label mt-1' style={{ fontSize: '12px', fontWeight: '500' }}>
                                                        Composition GST Number Holder Can Not Claim Input Tax Credit
                                                    </div>
                                                )}
                                            </div>)}
                                            {values.customer_type === 'company' && (
                                                <>
                                                    <div className="col-md-12">
                                                        <Text
                                                            label_name={"Company Name"}
                                                            placeholder=''
                                                            disabled={values.customer_type === 'company'}
                                                            name='company_name'
                                                            value={values.company_name || ''}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={errors.company_name && touched.company_name ? (<span className='text-danger form_label'>{errors.company_name}</span>) : null}
                                                        />
                                                    </div>

                                                </>
                                            )}
                                            <div className="col-md-12">
                                                <SingleSelect
                                                    closeMenu={true}
                                                    label_name='City'
                                                    disabled={values.customer_type === 'company'}
                                                    clear={true}
                                                    option={city_option}
                                                    name='city'
                                                    onInputChange={(e) => load_city(e)}
                                                    onChange={(e) => {
                                                        setFieldValue('city', e?.value || '');
                                                        setSid(e?.state || '')
                                                        setCountryId(e?.country || '')
                                                        setFieldValue('gst_code', e?.gst_code || '');
                                                        if (!e) {
                                                            setFieldTouched('city', true);
                                                        }
                                                    }
                                                    }
                                                    formatOptionLabel={(user) => (
                                                        <div>
                                                            <div>{user.label + ' , ' + user.state_name + ' ,  ' + user.country_name}</div>

                                                        </div>
                                                    )}
                                                    value={city_option?.find(val => val.value == values.city) || (values.city ? { value: values.city, label: localStorage.getItem('city_name') || 'Loading...', state_name: '', country_name: '' } : null)}
                                                    loading={cityLoading}
                                                    onBlur={handleBlur}
                                                    error={errors.city && touched.city ? (<span className='text-danger form_label' >{errors.city}</span>) : null}
                                                />
                                            </div>
                                            <div className="col-md-12">
                                                <TextArea
                                                    label_name={"Address"}
                                                    placeholder=''
                                                    disabled={values.customer_type === 'company'}
                                                    rows={1}
                                                    name='address'
                                                    value={values.address || ''}
                                                    onChange={handleAddressChange}
                                                    onBlur={handleBlur}
                                                    error={errors.address && touched.address ? (<span className='text-danger form_label'>{errors.address}</span>) : null}
                                                />
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-md-6 ">
                                        <div className='p-5'>
                                            <div className='p-4 rounded shadow-sm border bg-white' style={{ minHeight: '300px' }}>
                                                <h5 className="mb-4 border-bottom pb-2 text-primary fw-bold">Order Summary</h5>

                                                <div className="mb-4">
                                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                                        <h6 className="mb-0 fw-bold fs-5">{data?.name || 'Starter'} Plan</h6>
                                                        <span className="badge bg-soft-primary text-primary border px-2 py-1" style={{ fontSize: '0.75rem', backgroundColor: '#e7f1ff' }}>
                                                            {data?.plan_type === 'link' ? 'SHORT LINK' : 'BIO PAGE'}
                                                        </span>
                                                    </div>
                                                    <p className="text-muted small mb-0">{data?.description || 'Starter paid link'}</p>
                                                    <p className="text-muted small">Validity: <strong>{data?.days || 30} Days</strong></p>
                                                </div>

                                                <div className="plan-pricing-details mt-4 border rounded p-3" style={{ backgroundColor: '#f8f9fa' }}>
                                                    <div className="d-flex justify-content-between mb-2">
                                                        <span className="text-muted">Actual Price</span>
                                                        <span className="text-decoration-line-through text-muted fw-medium">{currencySymbol}{planMrp} {currencyCode}</span>
                                                    </div>
                                                    <div className="d-flex justify-content-between mb-2">
                                                        <span className="text-muted">Discounted Price</span>
                                                        <span className="fw-medium">{currencySymbol}{planPrice} {currencyCode}</span>
                                                    </div>
                                                    {couponData ?
                                                        <div className="d-flex justify-content-between mb-2">
                                                            <span className="text-success fw-medium">Coupon Price</span>
                                                            <span className="text-success fw-medium">-{currencySymbol}{couponAmount} {currencyCode}</span>
                                                        </div>
                                                        : ''}
                                                    {couponData ? <div className="d-flex justify-content-between mb-2">
                                                        <span className="text-muted">Final Discounted Price</span>
                                                        <span className="fw-medium">{currencySymbol}{discountedPrice} {currencyCode}</span>
                                                    </div> : ''}
                                                    {showTaxBreakdown && (
                                                        isSameState ?
                                                            <div className="d-flex justify-content-between mb-2">
                                                                <span className="text-muted">CGST Amount</span>
                                                                <span className="fw-medium">{currencySymbol}{taxAmount / 2} {currencyCode}</span>
                                                            </div> : ''
                                                    )}
                                                    {showTaxBreakdown && (
                                                        isSameState ? <div className="d-flex justify-content-between mb-2">
                                                            <span className="text-muted">SGST Amount</span>
                                                            <span className="fw-medium">{currencySymbol}{taxAmount / 2} {currencyCode}</span>
                                                        </div> :
                                                            <div className="d-flex justify-content-between mb-2">
                                                                <span className="text-muted">IGST Amount</span>
                                                                <span className="fw-medium">{currencySymbol}{taxAmount} {currencyCode}</span>
                                                            </div>
                                                    )}


                                                    <div className="d-flex justify-content-between border-top pt-2 mt-2">
                                                        <span className="fw-bold fs-5">Total Amount</span>
                                                        <span className="fw-bold fs-5 text-success">{currencySymbol}{totalAmount} {currencyCode}</span>
                                                    </div>
                                                    <div className="text-center mt-3">
                                                        <p className="text-success small fw-bold mb-0">
                                                            Wow! You save {currencySymbol}{couponData ? planMrp - discountedPrice : planMrp - planPrice} on this plan!
                                                        </p>
                                                    </div>
                                                </div>

                                                {/* Coupon Section */}
                                                <div className="mt-3 border rounded p-3" style={{ backgroundColor: '#ffffff' }}>
                                                    <h6 className="mb-2 text-primary fw-bold" style={{ fontSize: '15px' }}>Apply Coupon</h6>
                                                    <div className="d-flex gap-2">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Coupon Code"
                                                            value={couponCode}
                                                            onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
                                                            // disabled={appliedCoupon != null}
                                                            style={{ textTransform: 'uppercase' }}
                                                        />


                                                        {couponData ?
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger shadow-sm"
                                                                onClick={() =>
                                                                    removeCoupon()
                                                                }

                                                                style={{ whiteSpace: 'nowrap', minWidth: '85px' }}
                                                            >
                                                                Remove
                                                            </button> :
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary shadow-sm"
                                                                onClick={handleApplyCoupon}
                                                                disabled={!couponCode || couponLoading}
                                                                style={{ whiteSpace: 'nowrap', minWidth: '85px' }}
                                                            >
                                                                {couponLoading ? (
                                                                    <Spinner animation="border" size="sm" />
                                                                ) : 'Apply'}
                                                            </button>}

                                                    </div>
                                                    {couponMsg && (
                                                        <div className={`mt-2 small fw-medium ${couponError ? 'text-danger' : 'text-success'}`}>
                                                            {couponMsg}
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="col-md-12 mt-2">
                                                    <Form.Check type="checkbox" id="terms-checkbox">
                                                        <Form.Check.Input
                                                            type="checkbox"
                                                            name="terms"
                                                            checked={values.terms}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            isInvalid={touched.terms && !!errors.terms}
                                                            style={{ borderColor: '#b2b4b6', borderWidth: '2px' }}
                                                        />
                                                        <Form.Check.Label>
                                                            <h6 style={{ fontSize: '14px', cursor: 'pointer', display: 'inline' }} onClick={scrollToAttention}>
                                                                I agree to the <span className="text-primary text-decoration-underline">Above Terms</span>
                                                            </h6>
                                                        </Form.Check.Label>
                                                    </Form.Check>
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.terms}
                                                    </Form.Control.Feedback>
                                                </div>
                                                <div className="mt-4">
                                                    <button
                                                        type="button"
                                                        disabled={spinner ? true : false}
                                                        className={`btn w-100 py-3 fw-bold shadow-sm btn-primary`}
                                                        onClick={() => {

                                                            handleSubmit();
                                                        }}

                                                        style={{ borderRadius: '12px', letterSpacing: '0.5px', fontSize: '1.1rem' }}
                                                    >
                                                        {spinner ? (
                                                            <>
                                                                Processing...
                                                                <Spinner animation="border" size="sm" className="ms-2" />
                                                            </>
                                                        ) : (
                                                            'Proceed to Pay'
                                                        )}
                                                    </button>

                                                    {/* <p className="text-center text-muted x-small mt-3 mb-0" style={{ fontSize: '0.7rem' }}>
                                                        Secure 256-bit encrypted payments
                                                    </p> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Attention Required Section */}
                                    <div className="col-md-12 px-5 mt-4 order-first" ref={attentionRef}>
                                        <div className="p-4 rounded border shadow-sm mb-5" style={{ borderLeft: '6px solid #ffc107', backgroundColor: '#fffdf8' }}>
                                            <h5 className="text-dark fw-bold mb-3 d-flex align-items-center">
                                                <span className="bg-warning text-white rounded-circle d-inline-flex justify-content-center align-items-center me-2" style={{ width: '28px', height: '28px' }}>!</span>
                                                ATTENTION REQUIRED BEFORE PURCHASE
                                            </h5>

                                            <div className="text-dark medium" style={{ lineHeight: '1.7', fontSize: '1.0rem' }}>
                                                <p className="mb-3">
                                                    To avoid issues, you must test your Redirect Link/URL using our  <strong>Free Short Link </strong>(already available in your account or in every user account) before buying any paid plan.
                                                </p>

                                                <p className="mb-3">
                                                    This compatibility test ensures your link isn't blocked by firewalls or marked as malicious and that Redirect Link/URL is valid and acceptable as per our <strong> <Link to='/terms-and-conditions' target="_blank" className="text-decoration-none"><span className='text-primary'> Terms and Conditions </span> </Link> &  <Link to='/privacy-policy' target="_blank" className="text-decoration-none"><span className='text-primary'> Privacy Policy.</span></Link></strong>
                                                </p>

                                                <div className="row g-3 mb-3">
                                                    <div className="col-md-6">
                                                        <div className="p-3 border rounded bg-white h-100">
                                                            <strong>Bio Page Subscription Plan:</strong><br />
                                                            <span className="text-muted medium">User can download data related to <strong>Bio Link, Free Short Link, Available Content Link and Available Button Link.</strong></span>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="p-3 border rounded bg-white h-100">
                                                            <strong>Paid Short Link Plan:</strong><br />
                                                            <span className="text-muted medium">Users can download data only for purchased specific <strong> Paid Short Link.</strong></span>
                                                        </div>
                                                    </div>

                                                </div>

                                                <p className="mb-3">
                                                    <strong>IMP Point:</strong> All Links related validity, data collection, Any Redirect Link/URL testing, Any Redirect Link/URL acceptance & valid declaration, Any Redirect Link/URL disagreement & invalid declaration, and downloadable data is subject to our<strong> <Link to='/terms-and-conditions' target="_blank" className="text-decoration-none"><span className='text-primary'> Terms and Conditions </span> </Link> &  <Link to='/privacy-policy' target="_blank" className="text-decoration-none"><span className='text-primary'> Privacy Policy.</span></Link></strong>
                                                </p>

                                                <p className="mb-3"><strong>GST Calculation Record:</strong> If GST number is available, the "Bill To" details will be determined based on the available valid GST number; However, if GST number is not available or invalid, the "Bill To" details will be determined based on the entered city - state - country.</p>

                                                <div className="p-3 border-start border-danger border-4 rounded bg-white text-danger fw-bold mb-4 shadow-sm" style={{ borderLeft: '10px solid #dc3545 !important' }}>
                                                    No Refund or Credit: Because our services are digital and instant, all sales are final with no refunds or credits.
                                                </div>

                                                {/* <div className="p-3 rounded border border-primary border-dashed mt-4 d-flex align-items-center bg-white shadow-sm" style={{ cursor: 'pointer', transition: 'all 0.3s ease' }}>
                                                    <div className="form-check d-flex align-items-center gap-3">
                                                        <input
                                                            id="agree-checkbox"
                                                            type="checkbox"
                                                            className="form-check-input mt-0"
                                                            style={{ width: '28px', height: '28px', cursor: 'pointer', borderColor: '#0d6efd' }}
                                                            checked={accepted}
                                                            onChange={(e) => setAccepted(e.target.checked)}
                                                        />
                                                        <label htmlFor="agree-checkbox" className="form-check-label fw-bold text-primary mb-0" style={{ cursor: 'pointer', fontSize: '1.05rem' }}>
                                                            I have tested my Redirect URL and I accept the terms of this purchase.
                                                        </label>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </>
    )
}
